module.exports = __webpack_public_path__ + "static/img/ziyuan1.317e6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/ziyuan1.png
// module id = avX3
// module chunks = 0